/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StatusTag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import DraftTag from './DraftTag/index'
import FinalTag from './FinalTag/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function StatusTag({
  children,
  viewPath = "/DesignSystem/TasksCreateForm/Actions/Content/LetterPredefined/Content/StatusTag"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let documentNameValueData = fromData.useDataFormat({ viewPath,
context: 'document',
path: 'name',
format: fromHelpers.view,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: documentNameValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DraftTag'}>
<DraftTag
  viewPath={`${viewPath}/DraftTag`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'FinalTag'}>
<FinalTag
  viewPath={`${viewPath}/FinalTag`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}